/** Narrows to an object with unknown fields (not null, not an array). Canonical guard for the client. */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
